import { Builder, Model, PluralResponse } from 'coloquent'
import { AxiosResponse } from 'axios'

export default class Fetcher <T extends Model> {
  datas: T[] = []
  loading = false
  iterator: AsyncGenerator<T[] | void | unknown>
  builder: Builder<T>
  errors = 0
  hasNext = true

  constructor (builder: Builder<T>) {
    this.builder = builder
  }

  init (force = false) {
    if (force || !this.iterator) {
      this.datas = []
      this.iterator = this.fetchResource()
    }
  }

  async fetchPage () {
    this.init()
    await this.loadNext()
  }

  async fetchAll () {
    this.init()
    while (await this.loadNext()) {}
  }

  async loadNext (): Promise<boolean> {
    if (this.loading) return true
    const result = (await this.iterator.next()).value
    if (result) {
      this.datas.push(...result)
      return true
    }
    return false
  }

  async * fetchResource () {
    let missing = true
    let currentPage = 0
    while (missing && this.hasNext && this.errors < 3) {
      try {
        this.loading = true
        const res = await this.builder.get(currentPage)

        const httpResponse: any = res.getHttpClientResponse()
        if (httpResponse.axiosResponse) {
          const axiosResponse = httpResponse.axiosResponse as AxiosResponse
          this.hasNext = !!axiosResponse.data.links?.next
        }

        const data = res.getData() as T[]
        if (data) {
          this.loading = false
          const result = Array.isArray(data) ? data : [data]
          if (result.length) {
            yield result
          } else {
            missing = false
          }
        }
        currentPage = (res as PluralResponse).getPageNumber() + 1
      } catch (e) {
        console.error(e)
        this.loading = false
        this.errors++
        yield []
      }
    }
  }
}
